import React, { useState, Fragment } from "react";
import { Button, Modal, Icon } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { createRecord } from "../../store/action/createRecord";
import { fetchEdidata } from "../../store/action/ediResponse";
import Tooltip from "@material-ui/core/Tooltip";

import {
  usDocType,
  canadaDocType,
  ukDocType,
  CAactions,
  UKactions,
  DOC_ENTRY_7501,
  DOC_ENTRY_7501_NON_COMBINED,
  DOC_ENTRY_3461,
  DOC_ISF,
  EDI_FORMAT,
  DOC_CR_BOL_QUERY_REQUEST,
} from "./helper";
import { clearFileSuccessPopup } from "../../store/action/fileEdiRequest";
import { clearRecordDeletedPopup } from "../../store/action/deleteRecords";

function CreateEDI(props) {
  //debugger;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [dimmer, setDimmer] = useState(undefined);
  const [size, setSize] = useState(undefined);
  const [emptyDoc, setEmptyDoc] = useState(false);
  const [emptyAction, setEmptyAction] = useState(false);
  const [emptyEdiFormat, setemptyEdiFormat] = useState(false);
  //debugger;
  const shipmentID = useSelector(
    (state) => window.shipmentId || state.isf?.shipmentID || props.shipmentId
  );
  const [request, setRequest] = useState({
    shipmentId: shipmentID,
    actionType: "",
    documentType: "",
    ediFormat: "",
    pscOrEs: "ES_REQUESTX",
  });
  const usFormType =
    useSelector((state) => state.formTypeReducer?.usFormType) || "ES";
  const recordSubmitting = useSelector(
    (state) => state.ediRecordCreated?.loading
  );
  const onModalOpen = () => {
    setOpen(true);
    setDimmer("blurring");
    setSize("tiny");
  };
  const onModalClose = () => {
    let requestData = { ...request };
    requestData.actionType = "";
    requestData.documentType = "";
    requestData.pscOrEs = "ES_REQUESTX";
    setRequest(requestData);
    setEmptyDoc(false);
    setEmptyAction(false);
    setemptyEdiFormat(false);
    setOpen(false);
  };

  const country = useSelector(
    (state) =>
      window.shipmentCountry ||
      state.isf?.currentJobData.shipment.countryOfBusiness ||
      props.countryOfBusiness
  );
  //debugger;
  const getUSactions = (actionComing) => {
    let actionDispatch = [];
    switch (actionComing) {
      case "DOC_ENTRY_7501":
        actionDispatch = DOC_ENTRY_7501;
        break;
      case "DOC_ENTRY_7501_NON_COMBINED":
        actionDispatch = DOC_ENTRY_7501_NON_COMBINED;
        break;
      case "DOC_ENTRY_3461":
        actionDispatch = DOC_ENTRY_3461;
        break;
      case "DOC_ISF":
        actionDispatch = DOC_ISF;
        break;
      case "DOC_CR_BOL_QUERY_REQUEST":
        actionDispatch = DOC_CR_BOL_QUERY_REQUEST;
        break;
    }
    return actionDispatch;
  };
  const USactions = getUSactions(request.documentType);

  const getdocType = (country) => {
    let doctype = [];
    switch (country) {
      case "GB":
        doctype = ukDocType;
        break;
      case "US":
        doctype = usDocType;
        break;
      case "CA":
        doctype = canadaDocType;
        break;
    }
    return doctype;
  };

  const docType = getdocType(country || props.countryOfBusiness);
  const getaction = (country) => {
    let action = [];
    switch (country) {
      case "GB":
        action = UKactions;
        break;

      case "US":
        action = USactions;
        break;

      case "CA":
        action = CAactions;
        break;
    }
    return action;
  };
  const actions = getaction(country);
  // const EdiType = EDI_FORMAT;
  const EdiType = [
    { name: "CUSDEC", value: "EDI_CUSDEC" },
    { name: "SWI", value: "EDI_SWI_IID" },
  ];
  const onSubmit = async (event) => {
    event.preventDefault();
    let shipmentCountry = country;

    let isValidated = true;
    if (shipmentCountry === "CA") {
      if (
        request.actionType === "" &&
        request.documentType === "" &&
        request.ediFormat === ""
      ) {
        setEmptyDoc(true);
        setEmptyAction(true);
        setemptyEdiFormat(true);
        isValidated = false;
        return;
      }
    }
    if (shipmentCountry !== "CA") {
      if (request.actionType === "" && request.documentType === "") {
        setEmptyDoc(true);
        setEmptyAction(true);

        isValidated = false;
        return;
      }
    }

    if (request.actionType === "") {
      setEmptyAction(true);
      isValidated = false;
    }
    if (request.documentType === "") {
      setEmptyDoc(true);
      isValidated = false;
    }
    if (shipmentCountry === "CA" && request.ediFormat === "") {
      setemptyEdiFormat(true);
      isValidated = false;
    }
    if (isValidated) {
      await dispatch(createRecord(request, country, usFormType, request.pscOrEs=="PSC_REQUESTX"));
      dispatch(clearRecordDeletedPopup());
      dispatch(clearFileSuccessPopup());
      await setOpen(false);
      setEmptyDoc(false);
      setEmptyAction(false);
      setemptyEdiFormat(false);
      dispatch(fetchEdidata(shipmentID, shipmentCountry, usFormType, request.pscOrEs=="PSC_REQUESTX"));
    }
  };

  const onClose = () => {
    let requestData = { ...request };
    requestData.actionType = "";
    requestData.documentType = "";

    setRequest(requestData);
    setEmptyDoc(false);
    setEmptyAction(false);
    setemptyEdiFormat(false);
    setOpen(false);
  };
  const InputEvent = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    if (name === "actionType") {
      setEmptyAction(false);
    }
    if (name === "documentType") {
      setEmptyDoc(false);
    }
    if (name === "ediFormat") {
      setemptyEdiFormat(false);
    }
    setRequest((preValue) => {
      let baseObject = {
        pscOrEs: preValue.pscOrEs,
        actionType: preValue.actionType,
        documentType: preValue.documentType,
        ediFormat: preValue.ediFormat,
        shipmentId: shipmentID,
      };

      if (name === "documentType") {
        baseObject.pscOrEs = "ES_REQUESTX";
      }
      if (name === "actionType") {
        baseObject.actionType = value === "RETRACT"?"DELETE":value;
      } else {
        baseObject[name] = value;
      }
      return baseObject;
    });
  };

  //ADD NEW REQUEST
  return (
    <Fragment>
      <Modal
        onClose={onModalClose}
        onOpen={onModalOpen}
        open={open}
        dimmer={dimmer}
        size={size}
        trigger={
          <Tooltip
            title="Add New Request"
            placement="top"
            arrow
            aria-label="Add New Request"
          >
            <button className="trigger-button">Add New Request</button>
          </Tooltip>
        }
      >
        <Modal.Header>
          {" "}
          <h3 style={{ textAlign: "center", fontSize: "smaller" }}>
            Add New Request For ShipmentID : <b>{shipmentID} </b>
          </h3>
        </Modal.Header>
        <Modal.Content>
          <div style={{ display: "inline-flex" }}>
            <h3>Document type</h3>

            <select
              onChange={InputEvent}
              name="documentType"
              defaultValue={"DEFAULT"}
              style={emptyDoc ? { borderColor: "red" } : {}}
              className="selectoption"
            >
              <option value="DEFAULT" disabled>
                Please select one
              </option>
              {docType &&
                docType.map((dt, i) => (
                  <option key={i} value={`${dt.value}`}>
                    {dt.name}
                  </option>
                ))}
            </select>
          </div>
        </Modal.Content>
        <Modal.Content>
          <div style={{ display: "inline-flex", marginLeft: "9px" }}>
            <h3 style={{ marginLeft: "8px" }}>Request type</h3>

            <select
              onChange={InputEvent}
              name="actionType"
              defaultValue={"DEFAULT"}
              style={emptyAction ? { borderColor: "red" } : {}}
              className="selectoption"
            >
              <option value="DEFAULT" disabled>
                Please select one
              </option>
              {actions &&
                actions.map((at, i) => (
                  <option key={i} value={`${at}`}>
                    {at}
                  </option>
                ))}
            </select>
          </div>
        </Modal.Content>
        
        {country == "US" && request?.documentType == "DOC_ENTRY_7501_NON_COMBINED" &&
          <Modal.Content>
            <div style={{ display: "inline-flex", marginLeft: "9px" }}>
              <h3 style={{ marginLeft: "8px" }}>ES OR PSC</h3>

              <select
                onChange={InputEvent}
                name="pscOrEs"
                defaultValue={"DEFAULT"}
                style={emptyAction ? { borderColor: "red" } : {}}
                className="selectoption"
              >
                <option value="ES_REQUESTX">
                  ES
                </option>
                <option value="PSC_REQUESTX">
                  PSC
                </option>
              </select>
            </div>
          </Modal.Content>
        
        }

        {country === "CA" && (
          <Modal.Content>
            <div style={{ display: "inline-flex", marginLeft: "23px" }}>
              <h3 style={{ marginLeft: "8px" }}>EDI Format</h3>

              <select
                onChange={InputEvent}
                name="ediFormat"
                defaultValue={"DEFAULT"}
                style={emptyEdiFormat ? { borderColor: "red" } : {}}
                className="selectoption"
              >
                <option value="DEFAULT" disabled>
                  Please select one
                </option>
                {EdiType &&
                  EdiType.map((at, i) => (
                    <option key={i} value={`${at.value}`}>
                      {at.name}
                    </option>
                  ))}
              </select>
            </div>
          </Modal.Content>
        )}

        <Modal.Actions>
          <Button
            color="red"
            disabled={recordSubmitting ? true : false}
            onClick={onClose}
          >
            Don't create request
          </Button>
          <Button
            content="Create request"
            labelPosition="right"
            icon="checkmark"
            onClick={onSubmit}
            positive
            disabled={recordSubmitting ? true : false}
          />
        </Modal.Actions>
      </Modal>
    </Fragment>
  );
}

export default CreateEDI;
